<template>
  <pop-up-layout 
    :mini="true"
    :title="$t('incrustado.resetPassword')"
    :description="$t('incrustado.resetDescription')"
    :aceptar="$t('incrustado.resetAceptar')"
    :disabled="!valid"
    :saving="waitingForLoad"
    @volver="$parent.hide()"
    @aceptar="resetPassword()"
  >
    <v-form v-model="valid">
      <v-layout mb-3 justify-center>
        <v-text-field
          v-model="usermail"
          :name="usermail"
          :rules="[rules.obligatorio, rules.email, rules.max(100)]"
          :label="$t('incrustado.email')"
          required
        ></v-text-field>
      </v-layout>
    </v-form>
  </pop-up-layout>
</template>

<script>
import rulesMixin from '@/mixins/rules.js'
import { mapActions } from 'vuex'
export default {
  mixins: [rulesMixin],
  props: {
    usermailProp: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      usermail: '',
      valid: false,
      waitingForLoad: false
    }
  },
  created () {
    this.usermail = this.usermailProp
  },
  methods: {
    ...mapActions({
      resetPasswordApi: 'login/resetPassword',
      addAlert: 'alerts/add'
    }),
    async resetPassword () {
      this.waitingForLoad = true
      this.$parent.noCerrarInterno = true
      try {
        await this.resetPasswordApi(this.usermail)
        this.addAlert({texto: this.$t('incrustado.emailAlerta'), color: 'success'})
        this.$parent.hide()
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
      } catch (error) {
        this.waitingForLoad = false
        this.$parent.noCerrarInterno = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/incrustado/PopUpResetPassword.vue